import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { OdbcLinkedService } from 'app/model/linkedservice/odbc.linkedservice';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { ValueAdapter } from '../value.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OdbcLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                connectionString: 'secret',
                authenticationType: '*',
                userName: '*',
                password: 'secret',
                credential: 'secret',
                encryptedCredential: '*'
            },
            parameters: '*'
        }
    }
})
export class OdbcLinkedServiceAdapter extends LinkedServiceAdapter<OdbcLinkedService> {
    protected supportFirstClassParameterExperience = true;
    protected modelConstructor(): new () => OdbcLinkedService {
        return OdbcLinkedService;
    }

    protected model(): IModel {
        return OdbcLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: OdbcLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.OdbcLinkedService;
        properties.type = Metamodel.modelFor(OdbcLinkedService).name;

        const connectionString: string | Model.SecretBase = parameterizablePasswordOrAKVtoSecretBase(linkedService, OdbcLinkedService.CONNECTION_STRING, this.context);
        const userName: string = linkedService.authenticationType === 'Basic' ? this.valueToResource(linkedService, OdbcLinkedService.USER_NAME) : undefined;
        const password: string | Model.SecretBase = linkedService.authenticationType === 'Basic' ? parameterizablePasswordOrAKVtoSecretBase(linkedService, OdbcLinkedService.PASSOWRD, this.context) : undefined;
        const credential: string | Model.SecretBase = linkedService.credential ? parameterizablePasswordOrAKVtoSecretBase(linkedService, OdbcLinkedService.CREDENTIAL, this.context) : undefined;

        properties.typeProperties = {
            connectionString,
            authenticationType: linkedService.authenticationType,
            userName,
            password,
            credential
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(modelLinkedServiceResource: Model.LinkedServiceResource, linkedService: OdbcLinkedService): Promise<OdbcLinkedService> {
        const properties = modelLinkedServiceResource.properties as Model.OdbcLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.OdbcLinkedServiceTypeProperties = properties.typeProperties;
        parameterizableSecretBaseToModel(linkedService, OdbcLinkedService.CONNECTION_STRING, typeProperties.connectionString, this.context, true);
        ValueAdapter.toModel(linkedService, OdbcLinkedService.USER_NAME, typeProperties.userName);
        parameterizableSecretBaseToModel(linkedService, OdbcLinkedService.PASSOWRD, typeProperties.password, this.context, linkedService.authenticationType === 'Basic');
        if (typeProperties.credential) {
            parameterizableSecretBaseToModel(linkedService, OdbcLinkedService.CREDENTIAL, typeProperties.credential, this.context, true);
        }
        linkedService.authenticationType = typeProperties.authenticationType;
        return linkedService;
    }
}
